Commented
<span *ngIf="groupId && comment"
  >"<a
    uiSref="groups-show"
    [uiParams]="{ groupId: groupId, tab: 'comments' }"
    >{{ comment | truncate: 30:"..." }}</a
  >"</span
>
